import { ResponseModel } from '@agent/agent-interface/helpzone/knowledge-base/models/responseModel';

export interface KnowledgeBase {
  readonly suggestedResults: ResponseModel[];
  readonly searchResults: ResponseModel[];
}

export const initialKnowledgeBase: KnowledgeBase = {
  suggestedResults: [],
  searchResults: [],
};
